// Resolve o objeto "pagador" da API de Títulos a partir da pessoa logada e do
// endereço já preenchido no formulário do pedido. O pagador é sempre quem está
// logado no portal (nunca os dados de sociedade preenchidos no formulário,
// mesmo em pedidos de categoria Sociedade) — só o endereço vem do formulário,
// porque o cadastro da pessoa não tem um endereço próprio disponível aqui.
//
// Os pedidos usam 4 formatos diferentes de campos de endereço (ver
// config/shared/enderecoSections.js e sociedadeSections.js), por isso cada
// pedido declara no seu config.js qual desses formatos usa
// (config.tituloConfig.enderecoOrigem).

import { getTipoInscricaoUsuario } from './acessoPedidoService';

const unformatDigits = (value) => String(value || '').replace(/\D/g, '');

const RESOLVEDORES_ENDERECO = {
  // enderecoStep() — maioria dos pedidos de pessoa física
  residencial: (formData) => ({
    endereco: [formData.logradouroResidencial, formData.numeroResidencial].filter(Boolean).join(', '),
    cep: unformatDigits(formData.cepResidencial),
    bairro: formData.bairroResidencial,
    cidade: formData.municipioResidencial,
    uf: formData.ufResidencial
  }),

  // enderecoSociedadeStep() — pedidos de Sociedade sem endereço pessoal próprio
  sociedadeSimples: (formData) => ({
    endereco: [formData.rua, formData.numero].filter(Boolean).join(', '),
    cep: unformatDigits(formData.cep),
    bairro: formData.bairro,
    cidade: formData.municipio,
    uf: formData.estado
  }),

  // enderecoComercialStep() — endereço comercial completo (campos "...Profissional")
  comercial: (formData) => ({
    endereco: [formData.logradouroProfissional, formData.numeroProfissional].filter(Boolean).join(', '),
    cep: unformatDigits(formData.cepProfissional),
    bairro: formData.bairroProfissional,
    cidade: formData.municipioProfissional,
    uf: formData.ufProfissional
  }),

  // enderecoAdvogadoESociedadeStep() — usa a parte residencial do advogado, não a
  // profissional da sociedade (nomes de campo diferentes do formato "residencial")
  residencialAdvogadoSociedade: (formData) => ({
    endereco: [formData.ruaResidencial, formData.numeroResidencial].filter(Boolean).join(', '),
    cep: unformatDigits(formData.cepResidencial),
    bairro: formData.bairroResidencial,
    cidade: formData.municipioResidencial,
    uf: formData.estadoResidencial
  })
};

export const resolverEnderecoPagador = (enderecoOrigem, formData = {}) => {
  const resolvedor = RESOLVEDORES_ENDERECO[enderecoOrigem];
  if (!resolvedor) {
    throw new Error(`enderecoOrigem "${enderecoOrigem}" não é suportado pelo resolvedor de pagador`);
  }
  return resolvedor(formData);
};

/**
 * tipoInscricao: 1 = Pessoa Física (CPF, 11 dígitos), 2 = Pessoa Jurídica (CNPJ, 14 dígitos).
 */
export const resolverPagador = (user, enderecoOrigem, formData = {}) => {
  const documento = unformatDigits(user?.documento);
  const tipoInscricao = getTipoInscricaoUsuario(user) === 'PJ' ? 2 : 1;
  const endereco = resolverEnderecoPagador(enderecoOrigem, formData);

  return {
    tipoInscricao,
    numeroInscricao: documento,
    nome: user?.nome,
    ...endereco
  };
};
